import * as React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      alignItems: "center",
      display: "flex",
      flexDirection: "column",
      height: "calc(100vh - 80px)",
      justifyContent: "center",
      width: "100%"
    },
    header: {
      marginBottom: theme.spacing(4)
    }
  });

type State = {};

type Props = {
  classes?: any;
};

class Loading extends React.Component<Props, State> {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container}>
        <Typography className={classes.header} variant="h2">
          We're loading...
        </Typography>
        <CircularProgress />
      </div>
    );
  }
}

export default withStyles(styles)(Loading);
